import { InframailIpsDomain } from '../types';
import { SelectedDomainsForNewEmailAccounts } from '../../email-accounts/types/create-email-infrastructure';
import { EmailAccountInfrastructureServiceProvider } from '../../email-accounts/enums/create-email-infrastructure';

export const formatInframailIpsData = (
  meta: {
    id: string;
    ipAddress: string;
  },
  inframailIps: InframailIpsDomain[],
): SelectedDomainsForNewEmailAccounts => ({
  id: meta.id,
  name: meta.ipAddress,
  emailServiceProvider: EmailAccountInfrastructureServiceProvider.Inframail,
  isMultipleDomains: true,
  domains: inframailIps.map((domain) => ({
    id: domain.id,
    name: domain.name,
    status: domain.status,
    orderId: domain.orderId,
    mailboxes: domain.mailboxes.map((m) => ({ id: m.id, email: m.email })),
  })),
});
